"use client";

import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/productDetail.css"
import coconut1 from "../assets/images/COCONUT OIL 1L .webp"
import coconut2 from "../assets/images/COCONUT USES .webp"
import coconut3 from "../assets/images/COCONUT OIL 1L BACK .webp"
import coconut4 from "../assets/images/coco5L.webp"
import ground1 from "../assets/images/Groundnut oil 1L .webp"
import ground from "../assets/images/Groundnut uses .webp"
import ground2 from "../assets/images/Groundnut oil 500ml .webp"
import ground3 from "../assets/images/Groundnut oil 500ml back .webp"
import ground4 from "../assets/images/GROUNDNUT.webp"
import ground5 from "../assets/images/groundbenefit.png"
// import ground1 from "../assets/images/COCONUT OIL 500ML BACK .webp"
import juggery from "../assets/images/jaggeryposterpng1.png"
import juggery1 from "../assets/images/jaggeryposterpng2.png"
import juggery2 from "../assets/images/jaggeryposterpng3.png"
import juggery3 from "../assets/images/jaggeryposterpng4.png"
import juggery4 from "../assets/images/jaggeryposterpng5.png"
import ses from "../assets/images/SESAME OIL 1L .webp"
import ses1 from "../assets/images/SESAME 1L BACK .webp"
import ses2 from "../assets/images/SESAME OIL 500ML .webp"
import ses3 from "../assets/images/SESAME OIL 500ML BACK .webp"
import ses4 from "../assets/images/sesambenefit.png"
import mus from "../assets/images/MUSTARD OIL 1L .webp"
import mus1 from "../assets/images/MUSTARD OIL 1L BACK .webp"
import mus2 from "../assets/images/MUSTARD OIL 500ML .webp"
import mus3 from "../assets/images/MUSTARD OIL 500ML BACK.webp"
import mus4 from "../assets/images/mustarBen.png"
import cas from "../assets/images/CASTOR OIL 1L .webp"
import cas1 from "../assets/images/CASTOR OIL 1L BACK .webp"
import cas2 from "../assets/images/CASTOR OIL 500ML .webp"
import cas3 from "../assets/images/CASTOR OIL 500ML BACK .webp"
import cas4 from "../assets/images/castbenefit.png"
import deep from "../assets/images/DEEPAM OIL 1L .webp"
import deep1 from "../assets/images/DEEPAM OIL 1L BACK ..webp"
import deep2 from "../assets/images/DEEPAM OIL 500ML .webp"
import deep3 from "../assets/images/DEEPAAM  OIL  500ML BACK .webp"
import chips2 from "../assets/images/chocolate.png";
import chips3 from "../assets/images/chocolate_original_2_11zon.webp";
import chips4 from "../assets/images/cholate_vanila_4_11zon.webp";
import chips5 from "../assets/images/chocolate_Rose_3_11zon.png";
import chipsthree from "../assets/images/chocolate_ll_three_package_1_11zon.png";
import butterunsweet from "../assets/images/PEANUT BUTTER Unsweetened .webp"
import butterJuggery from "../assets/images/PEANUT BUTTER JAGGERY .webp"
import butterChoclate from "../assets/images/PEANUT BUTTER CHOCOLATE .webp"
import ghee1 from "../assets/images/ghee_Jagger.webp";
import ghee2 from "../assets/images/ghee_Jagger2.webp";
import hon1 from "../assets/images/honey1.png";
import hon2 from "../assets/images/honey2.png";
import hon3 from "../assets/images/honey3.png";
import hon4 from "../assets/images/honey4.png";
import hon5 from "../assets/images/honey5.png";
import hon6 from "../assets/images/honey6.png";
import csugar from "../assets/images/csugar.png";
import csugar1 from "../assets/images/csugar1.png";
import csugar2 from "../assets/images/csugar2.png";
import csugar3 from "../assets/images/csugar3.png";
import csugar4 from "../assets/images/csugar4.png";
import csugar6 from "../assets/images/csugar6.png";
import palm from "../assets/images/palm.png";
import palm1 from "../assets/images/palm1.png";
import brick from "../assets/images/brick.webp";
import brick1 from "../assets/images/brick1.webp";
import bowl from "../assets/images/bowl.webp";
import bowl1 from "../assets/images/bowl1.webp";
import salt from "../assets/images/salt.webp";
import salt1 from "../assets/images/salt1.webp";
import salt2 from "../assets/images/salt2.webp";
import almond from "../assets/images/almond.webp";
import almond1 from "../assets/images/almond1.webp";
import almond2 from "../assets/images/almond2.webp";
import almond3 from "../assets/images/almond3.webp";
import almond4 from "../assets/images/almond4.webp";



const products = [
    {
        id: 1,
        name: "Haronics Wood/Cold Pressed Coconut Oil | 100% Natural | Unrefined | Hexane-Free",
        description:
            "Pure, natural, and nutrient-rich coconut oil extracted using traditional wooden Ghani method to retain aroma, flavor, and nutrients.",
        longDescription:
            "Experience the goodness of nature with Haronics Cold Pressed Coconut Oil, extracted using the traditional wooden Ghani method to retain maximum nutrients, aroma, and flavor. Made from fresh, high-quality coconuts sourced from trusted farms, our oil is 100% pure, unrefined, and free from chemicals or preservatives. Rich in lauric acid, antioxidants, and healthy fats, this versatile oil is perfect for cooking, skincare, and haircare. Whether you're frying, sautéing, oil-pulling, or moisturizing—Haronics Coconut Oil is your all-natural companion for holistic wellness.",
        price: 250,
        originalPrice: 300,
        discount: 17,
        rating: 4.8,
        reviewCount: 110,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Coconut Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Cold Pressed in Wooden Churners",
            "Chemical-Free & Unrefined",
            "Rich in Antioxidants, Vitamin E, and MCTs",
            "Boosts Immunity & Digestion",
            "Ideal for Cooking & Skin Care"
        ],
        specifications: [
            { name: "Type", value: "Coconut Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500ML", price: 300, originalPrice: 350 },
            { name: "1L", price: 600, originalPrice: 650 },
            { name: "5L", price: 3000, originalPrice: 3200 }
        ],
        images: [
            coconut1,
            coconut3,
            coconut4,
            coconut2,

        ],
        offers: [
            "10% off on first purchase",
            "Buy 2 Get 1 Free on Haronics Oils",
            "Free delivery on orders above ₹499"
        ],
        benefits: [
            "1. Moisturizes Skin and Hair – Acts as a natural moisturizer, helping to treat dry skin and improve hair health and shine",
            "2. Boosts Metabolism – Contains medium-chain triglycerides (MCTs) that may help increase energy and support weight loss.",
            "3. Improves Digestion – Helps in the absorption of fat-soluble vitamins and has antimicrobial properties that support gut health.",
            "4. Supports Immunity – Contains lauric acid, which has antibacterial and antiviral properties that help strengthen the immune system.",
            "5. Good for Cooking – Has a high smoke point, making it ideal for frying and baking while also adding a mild, pleasant flavor."
        ],
        storage: [
            "1. Store in a Cool, Dark Place – Keep coconut oil away from direct sunlight and heat to maintain its quality and shelf life.",
            "2. Use an Airtight Container – Always close the lid tightly to prevent contamination and oxidation. You can refrigerate it if you prefer a solid form.",
        ],
        reviews: [],
        questions: [],
        relatedProducts: [2, 3, 4]
    },
    {
        id: 2,
        name: "Haronics Wood/Cold Pressed Groundnut Oil | 100% Natural | Unrefined | Hexane-Free",
        description:
            "Wholesome flavor and natural nutrition—perfect for Indian cooking. Made using traditional Ghani method to retain nutrients and flavor.",
        longDescription:
            "Haronics Cold Pressed Groundnut Oil is a heart-healthy choice crafted through the traditional wooden Ghani method, ensuring the oil retains its natural aroma, rich nutrients, and golden clarity. Extracted from premium-quality groundnuts without the use of heat or chemicals, our oil is unrefined, pure, and packed with essential fatty acids and antioxidants. Its light texture and nutty flavor make it perfect for Indian cooking—whether for deep frying, sautéing, or tadkas. Naturally rich in Vitamin E and plant sterols, this oil supports heart health, reduces inflammation, and promotes overall well-being.",
        price: 360,
        originalPrice: 450,
        discount: 20,
        rating: 4.7,
        reviewCount: 80,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Groundnut Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Cold Pressed in Wooden Churners",
            "Unrefined & Chemical-Free",
            "Rich in Vitamin E & Omega-6",
            "Heart-Friendly Oil",
            "High Smoke Point"
        ],
        specifications: [
            { name: "Type", value: "Groundnut Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500ML", price: 200, originalPrice: 300 },
            { name: "1L", price: 360, originalPrice: 450 },
            { name: "5L", price: 1700, originalPrice: 2000 }
        ],
        images: [


            ground1,
            ground2,
            ground3,
            ground5,
            ground4,
            ground,
        ],
        offers: [
            "5% Cashback on Haronics purchases",
            "Buy 5L and get ₹100 off",
            "Free shipping over ₹499"
        ],
        benefits: [
            "1. Heart-Healthy Fats – Rich in monounsaturated and polyunsaturated fats, which help reduce bad cholesterol (LDL) and support heart health.",
            "2. Rich in Vitamin E – Acts as an antioxidant, protecting the skin and body cells from damage caused by free radicals.",
            "3. Improves Digestion – Helps in the absorption of fat-soluble vitamins and has antimicrobial properties that support gut health.",
            "4. Improves Skin Health – Can be used topically to moisturize skin and reduce inflammation.",
            "5. High Smoke Point – Ideal for deep-frying and high-temperature cooking without breaking down into harmful compounds."
        ],
        storage: [
            "1. Store in a Cool, Dry Place – Keep groundnut oil in a cool cupboard away from sunlight and heat sources to prevent it from becoming rancid.",
            "2. Use a Sealed, Dark Bottle – Prefer airtight, dark-colored glass or metal containers to preserve its flavor and nutritional quality.",
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 3, 4]
    },
    // Additional products will be inserted here...
    {
        id: 3,
        name: "Haronics Wood/Cold Pressed Sesame Oil | 100% Natural | Unrefined | Hexane-Free",
        description:
            "Ancient Ayurvedic sesame oil—rich in nutrients and perfect for cooking and skincare.",
        longDescription:
            "Haronics Cold Pressed Sesame Oil is a timeless elixir, extracted using the traditional wooden Ghani method to preserve its natural nutrients, aroma, and earthy golden color. Made from premium-grade sesame seeds, our oil is 100% pure, unrefined, and free from chemicals or preservatives. Rich in antioxidants, Vitamin E, and essential fatty acids, sesame oil supports heart health, strengthens immunity, nourishes skin and hair, and aids in digestion.",
        price: 500,
        originalPrice: 550,
        discount: 9,
        rating: 4.9,
        reviewCount: 103,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Sesame Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Cold Pressed in Wooden Churners",
            "Rich in Antioxidants & Healthy Fats",
            "Supports Heart, Skin & Joint Health",
            "Traditional Ayurvedic Use",
            "High Smoke Point"
        ],
        specifications: [
            { name: "Type", value: "Sesame Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500ML", price: 250, originalPrice: 300 },
            { name: "1L", price: 500, originalPrice: 550 },
            { name: "5L", price: 2400, originalPrice: 2800 }
        ],
        images: [ses, ses1, ses2, ses3,ses4],
        offers: [
            "Flat ₹20 off on 500ML",
            "10% off with 2 bottles combo",
            "Free shipping for all sizes"
        ],
        benefits: [
            "1. Rich in Antioxidants – Contains sesamol and sesamin, which help fight free radicals and reduce inflammation.",
            "2. Supports Joint and Bone Health – Loaded with calcium, zinc, and copper, which are essential for maintaining strong bones and reducing joint pain.",
            "3. Promotes Healthy Skin and Hair – Deeply nourishes skin and scalp, helps reduce dryness, and adds natural shine to hair.",
        ],
        storage: [
            "1. Store in a Cool, Dark Place – Keep the oil away from sunlight and heat to preserve its nutrients and prevent spoilage.",
            "2. Use a Glass or Stainless Steel Container – Avoid plastic; tightly seal the container after every use to maintain freshness and prevent oxidation.",
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 2, 3]
    },
    {
        id: 4,
        name: "Haronics Wood/Cold Pressed Mustard Oil | 100% Natural | Unrefined | Hexane-Free",
        description:
            "Bold flavor and powerful health benefits—traditionally extracted mustard oil with rich aroma and golden hue.",
        longDescription:
            "Haronics Cold Pressed Mustard Oil is extracted using the traditional wooden Ghani method to preserve its natural pungency, rich golden hue, and powerful health benefits. Made from high-quality mustard seeds, this oil is 100% pure, unrefined, and free from any additives or chemicals. Renowned for its antibacterial, antifungal, and anti-inflammatory properties, mustard oil supports immunity, improves circulation, and promotes healthy skin and hair. With its bold, earthy flavor, it’s perfect for Indian cooking—from pickles and curries to tadkas and marinades.",
        price: 450,
        originalPrice: 550,
        discount: 18,
        rating: 4.8,
        reviewCount: 82,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Mustard Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Cold Pressed in Wooden Churners",
            "Unrefined & Chemical-Free",
            "Rich in Omega-3 & Omega-6 Fatty Acids",
            "Natural Antibacterial & Antifungal Properties",
            "High Smoke Point"
        ],
        specifications: [
            { name: "Type", value: "Mustard Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500ML", price: 250, originalPrice: 300 },
            { name: "1L", price: 450, originalPrice: 550 },
            { name: "5L", price: 2200, originalPrice: 2500 }
        ],
        images: [mus, mus1, mus2, mus3,mus4],
        offers: [
            "Extra ₹50 off with coupon",
            "Buy 1L & get ₹25 cashback",
            "Free shipping above ₹499"
        ],
        benefits: [
            "1. Improves heart health with monounsaturated fats and omega-3s.",
            "2. Boosts immunity with natural antibacterial and antiviral properties.",
            "3. Relieves cold, cough, and joint pain when used for massage or inhalation."
        ],
        storage: [
            "1. Store in a cool, dry place away from sunlight to prevent rancidity.",
            "2. Use an airtight glass or steel container to maintain aroma and quality."
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 2, 4]
    },
    {
        id: 5,
        name: "Haronics Wood/Cold Pressed Castor Oil | 100% Natural | Unrefined | Hexane-Free",
        description:
            "Multipurpose castor oil for hair, skin, and wellness—deeply moisturizing and detoxifying.",
        longDescription:
            "Haronics Cold Pressed Castor Oil is a natural powerhouse extracted through the traditional cold pressing method to retain its rich nutrients, thickness, and therapeutic properties. Made from high-quality castor seeds, our oil is 100% pure, unrefined, and free from chemicals, making it safe for skin, hair, and wellness use.",
        price: 400,
        originalPrice: 550,
        discount: 27,
        rating: 4.9,
        reviewCount: 76,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Castor Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Promotes Hair Growth & Scalp Health",
            "Natural Skin Moisturizer",
            "Supports Digestive Health",
            "Rich in Ricinoleic Acid",
            "Chemical-Free & Multipurpose"
        ],
        specifications: [
            { name: "Type", value: "Castor Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500ML", price: 200, originalPrice: 350 },
            { name: "1L", price: 400, originalPrice: 550 }
        ],
        images: [cas, cas1, cas2, cas3,cas4],
        offers: [
            "Buy 1L and get 10% off",
            "Combo offer: Buy with Coconut Oil & Save ₹100",
            "Free Shipping on All Orders"
        ],
        reviews: [],
        questions: [],
        benefits: [
            "1. Promotes hair growth and strengthens roots.",
            "2. Acts as a natural laxative for digestive relief.",
            "3. Moisturizes dry skin and heals inflammation."
        ],
        storage: [
            "1. Store in a cool, dry place away from direct sunlight.",
            "2. Use a tightly sealed glass or steel container to preserve purity."
        ],
        relatedProducts: [1, 2, 3]
    },
    {
        id: 6,
        name: "Haronics Deepam Oil | 100% Natural & Chemical-Free | Blend of 5 Pooja Oils | Unscented | Low Soot",
        description:
            "Sacred blend for divine light—crafted with purity for spiritual rituals.",
        longDescription:
            "Haronics Cold Pressed Deepa Oil is a sacred blend crafted for spiritual purity and lasting illumination. Extracted through the traditional wooden Ghani method, this oil is made using high-quality natural ingredients to ensure a clean, smokeless burn with a bright, steady flame. 100% pure and chemical-free, it is ideal for daily pujas, rituals, and festive occasions.",
        price: 250,
        originalPrice: 350,
        discount: 29,
        rating: 4.8,
        reviewCount: 71,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Deepam Oil",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Traditional",
            "Clean & Long-Lasting Flame",
            "Free from Harmful Chemicals",
            "Pleasant, Mild Aroma",
            "Minimal Soot & Smoke",
            "Ideal for Daily Use"
        ],
        specifications: [
            { name: "Type", value: "Pooja Oil" },
            { name: "Packaging", value: "Pet Bottle" },
            { name: "Usage", value: "For Lamps & Rituals" },
            { name: "Country of Origin", value: "India" },
            { name: "Shelf Life", value: "9 months" }
        ],
        variants: [
            { name: "500ML", price: 150, originalPrice: 200 },
            { name: "1L", price: 250, originalPrice: 350 }
        ],
        images: [deep, deep1, deep2, deep3],
        offers: [
            "Festival Combo Discount Available",
            "Free Shipping on orders ₹300+",
            "Extra ₹10 off on prepaid orders"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 5],
        benefits: [
            "1. Traditionally used for lighting lamps during prayers for positivity and purity.",
            "2. Made from natural oils like sesame or castor, which are non-toxic and safe for indoor use.",
            "3. Creates a calming and spiritual ambiance during rituals."
        ],
        storage: [
            "1. Store in a cool, dark place away from heat sources.",
            "2. Keep in a sealed container to prevent spillage and contamination."
        ]
    },
    {
        id: 8,
        name: "Haronics Baked Coconut Chips – Original",
        description: "Pure Coconut. Pure Crunch. Pure Satisfaction.",
        longDescription: "Savor the authentic taste of nature with Haronics Baked Coconut Chips – Original. Made from handpicked, premium coconuts and baked—not fried—to lock in flavor and crunch. With no added sugar or flavoring, it's coconut in its cleanest form, ideal for snacking or as a topping for bowls and cereals.",
        price: 80,
        originalPrice: 100,
        discount: 20,
        rating: 4.7,
        reviewCount: 87,
        inStock: true,
        freeDelivery: true,
        category: "Chips",
        subCategory: "Coconut Chips",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Natural & Additive-Free",
            "Baked, Not Fried",
            "Rich in Fiber & MCTs",
            "Gluten-Free & Vegan",
            "Ideal Snack or Topping",
            "No Preservatives or Artificial Flavors"
        ],
        specifications: [
            { name: "Type", value: "Coconut Chips" },
            { name: "Flavor", value: "Original" },
            { name: "Weight", value: "30gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "30g", price: 50, originalPrice: 80 }
        ],
        images: [chips3],
        offers: [
            "Buy 3 get 1 free",
            "Free shipping on ₹299+"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [14, 15, 16],
        benefits: [
            "1. Healthy snack rich in fiber and healthy fats.",
            "2. Made without added sugars or preservatives.",
            "3. Supports digestion and provides quick energy."
        ],
        storage: [
            "1. Store in an airtight container to retain crunchiness.",
            "2. Keep in a cool, dry place away from moisture."
        ]
    },
    {
        id: 9,
        name: "Haronics Baked Coconut Chips – Vanilla",
        description: "Subtle Sweetness. Tropical Crunch. Naturally Delicious.",
        longDescription: "Experience a blissful blend of creamy vanilla and the natural richness of coconut with Haronics Baked Coconut Chips – Vanilla. These chips are lightly baked and infused with real vanilla for a sweet and satisfying crunch—without frying, artificial flavors, or preservatives.",
        price: 90,
        originalPrice: 110,
        discount: 18,
        rating: 4.8,
        reviewCount: 75,
        inStock: true,
        freeDelivery: true,
        category: "Chips",
        subCategory: "Coconut Chips",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Infused with Real Vanilla",
            "Baked, Not Fried",
            "No Preservatives or Artificial Additives",
            "Vegan & Gluten-Free",
            "Rich in MCTs and Fiber",
            "Perfect On-the-Go Snack"
        ],
        specifications: [
            { name: "Type", value: "Coconut Chips" },
            { name: "Flavor", value: "Vanilla" },
            { name: "Weight", value: "30gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "30g", price: 50, originalPrice: 80 }
        ],
        images: [chips4],
        offers: [
            "Get ₹10 off on prepaid orders",
            "Buy 3 or more and save 15%"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [13, 15, 16],
        benefits: [
            "1. Combines the health benefits of coconut with natural vanilla flavor.",
            "2. Provides a tasty, low-carb snack option.",
            "3. Rich in MCTs that help boost metabolism."
        ],
        storage: [
            "1. Store in a cool, dry place to preserve freshness.",
            "2. Keep the packet sealed after opening to maintain crispness."
        ]
    },
    {
        id: 10,
        name: "Haronics Baked Coconut Chips – Rose",
        description: "Delicate Floral Aroma. Exotic Crunch. Naturally Elegant.",
        longDescription: "Indulge in the exotic fusion of coconut and floral rose with Haronics Baked Coconut Chips – Rose. These chips are gently baked and infused with natural rose essence for a refreshing and elegant snacking experience—free from artificial ingredients.",
        price: 90,
        originalPrice: 110,
        discount: 18,
        rating: 4.7,
        reviewCount: 78,
        inStock: true,
        freeDelivery: true,
        category: "Chips",
        subCategory: "Coconut Chips",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Infused with Natural Rose Essence",
            "Baked to Crisp Perfection",
            "No Artificial Colors or Flavors",
            "Vegan & Gluten-Free",
            "High in Fiber & MCTs",
            "Great for Gifting & Snacking"
        ],
        specifications: [
            { name: "Type", value: "Coconut Chips" },
            { name: "Flavor", value: "Rose" },
            { name: "Weight", value: "30gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "30g", price: 50, originalPrice: 80 }
        ],
        images: [chips5],
        offers: [
            "Combo discounts available",
            "Free delivery above ₹299"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [13, 14, 16],
        benefits: [
            "1. Infused with natural rose flavor for a unique taste.",
            "2. Rich in antioxidants and dietary fiber.",
            "3. A heart-healthy snack option with no trans fats."
        ],
        storage: [
            "1. Store in a dry place away from direct sunlight.",
            "2. Seal the packet properly after opening to keep the chips crunchy."
        ]
    },
    {
        id: 7,
        name: "Haronics Baked Coconut Chips – Chocolate",
        description: "Rich Cocoa. Tropical Crunch. Guilt-Free Indulgence.",
        longDescription: "Satisfy your chocolate cravings the healthy way with Haronics Baked Coconut Chips – Chocolate. These chips are baked and dusted with real cocoa, offering a crispy, chocolaty snack without refined sugar or preservatives.",
        price: 100,
        originalPrice: 120,
        discount: 17,
        rating: 4.8,
        reviewCount: 90,
        inStock: true,
        freeDelivery: true,
        category: "Chips",
        subCategory: "Coconut Chips",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Infused with Real Cocoa Powder",
            "No Refined Sugar or Additives",
            "Baked, Not Fried",
            "Vegan & Gluten-Free",
            "Perfect for Cravings & Desserts",
            "High in Healthy Fats & Fiber"
        ],
        specifications: [
            { name: "Type", value: "Coconut Chips" },
            { name: "Flavor", value: "Chocolate" },
            { name: "Weight", value: "30gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "30g", price: 50, originalPrice: 80 }
        ],
        images: [chips2],
        offers: [
            "Buy 2 and save ₹15",
            "Free shipping over ₹299"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [13, 14, 15],
        benefits: [
            "1. Combines coconut nutrition with delicious chocolate flavor.",
            "2. Satisfies sweet cravings while staying healthy.",
            "3. Contains antioxidants and good fats for energy."
        ],
        storage: [
            "1. Store in a cool, dry place to avoid melting or sogginess.",
            "2. Keep sealed after use to retain crispness and flavor."
        ]
    },
    {
        id: 11,
        name: "Haronics Chips - Rose, Vanilla AND Original Chips",
        description: "Rich Cocoa. Tropical Crunch. Guilt-Free Indulgence.",
        longDescription: "Satisfy your chocolate cravings the healthy way with Haronics Baked Coconut Chips – Rose, Vanilla AND Original Chips. These chips are baked and dusted with real cocoa, offering a crispy, chocolaty snack without refined sugar or preservatives.",
        price: 100,
        originalPrice: 120,
        discount: 17,
        rating: 4.8,
        reviewCount: 90,
        inStock: true,
        freeDelivery: true,
        category: "Chips",
        subCategory: "Coconut Chips",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Infused with Real Cocoa Powder",
            "No Refined Sugar or Additives",
            "Baked, Not Fried",
            "Vegan & Gluten-Free",
            "Perfect for Cravings & Desserts",
            "High in Healthy Fats & Fiber"
        ],
        specifications: [
            { name: "Type", value: "Coconut Chips" },
            { name: "Flavor", value: "Rose, Vanilla AND Original Chips" },
            { name: "Weight", value: "90gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "30g", price: 150, originalPrice: 200 }
        ],
        images: [chipsthree],
        offers: [
            "Buy 2 and save ₹15",
            "Free shipping over ₹299"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [13, 14, 15],
        benefits: [
            "1. Combines coconut nutrition with delicious chocolate flavor.",
            "2. Satisfies sweet cravings while staying healthy.",
            "3. Contains antioxidants and good fats for energy."
        ],
        storage: [
            "1. Store in a cool, dry place to avoid melting or sogginess.",
            "2. Keep sealed after use to retain crispness and flavor."
        ]
    },
    {
        id: 12,
        name: "Haronics Peanut Butter – Unsweetened",
        description: "Just Peanuts. Pure Power.",
        longDescription: "Haronics Unsweetened Peanut Butter is made from 100% premium roasted peanuts with absolutely no added sugar, salt, or preservatives. Crafted in small batches for freshness and flavor, this natural spread delivers rich taste, creamy texture, and pure nutritional value—perfect for those who want clean energy and guilt-free indulgence.",
        price: 280,
        originalPrice: 350,
        discount: 20,
        rating: 4.8,
        reviewCount: 92,
        inStock: true,
        freeDelivery: true,
        category: "Butter",
        subCategory: "Peanut Butter",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure Roasted Peanuts",
            "No Sugar, Salt, or Preservatives",
            "Rich in Protein & Healthy Fats",
            "Gluten-Free & Vegan",
            "No Palm Oil",
            "Clean & Guilt-Free Indulgence"
        ],
        specifications: [
            { name: "Type", value: "Unsweetened Peanut Butter" },
            { name: "Weight", value: "300gm" },
            { name: "Packaging", value: "Jar" },
            { name: "Diet Type", value: "Vegan, Gluten-Free" },
            { name: "Country of Origin", value: "India" }
        ],
        variants: [
            { name: "300gm", price: 280, originalPrice: 350 }
        ],
        images: [butterunsweet],
        offers: [
            "5% off on first order",
            "Free shipping on ₹499+"
        ],
        reviews: [],
        questions: [],
        benefits: [
            "1. High in protein and healthy fats, supports muscle growth.",
            "2. No added sugar, making it diabetic-friendly.",
            "3. Great source of energy and dietary fiber."
        ],
        storage: [
            "1. Store in a cool, dry place away from sunlight.",
            "2. Stir well and refrigerate after opening to maintain freshness."
        ],
        relatedProducts: [9, 10]
    },
    {
        id: 13,
        name: "Haronics Peanut Butter – Jaggery Sweetened",
        description: "Natural Energy. Nourishing Taste.",
        longDescription: "Haronics Peanut Butter with Jaggery is a wholesome blend of premium roasted peanuts and natural cane jaggery—offering the perfect balance of rich, nutty flavor and traditional sweetness. Free from refined sugar, hydrogenated fats, and preservatives, this spread is packed with protein, healthy fats, and essential minerals.",
        price: 300,
        originalPrice: 350,
        discount: 14,
        rating: 4.7,
        reviewCount: 88,
        inStock: true,
        freeDelivery: true,
        category: "Butter",
        subCategory: "Peanut Butter",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Natural Cane Jaggery",
            "100% Natural Ingredients",
            "Rich in Protein & Fiber",
            "No Refined Sugar or Preservatives",
            "Vegan & Gluten-Free",
            "No Palm Oil or Hydrogenated Fats"
        ],
        specifications: [
            { name: "Type", value: "Jaggery Peanut Butter" },
            { name: "Weight", value: "300gm" },
            { name: "Packaging", value: "Jar" },
            { name: "Diet Type", value: "Vegan, Gluten-Free" },
            { name: "Country of Origin", value: "India" }
        ],
        variants: [
            { name: "300gm", price: 300, originalPrice: 350 }
        ],
        images: [butterJuggery],
        offers: [
            "Combo offer available",
            "Free shipping on ₹499+"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [8, 10],
        benefits: [
            "1. Natural sweetener (jaggery) adds minerals like iron and calcium.",
            "2. Provides quick energy with healthy fats and carbs.",
            "3. Tasty and nutritious snack option for kids and adults."
        ],
        storage: [
            "1. Store in a cool place; refrigeration optional but recommended after opening.",
            "2. Use a clean, dry spoon to avoid contamination."
        ],
    },
    {
        id: 14,
        name: "Haronics Peanut Butter – Chocolate",
        description: "Indulgent Flavor. Nutritious Delight.",
        longDescription: "Haronics Peanut Butter Chocolate is a delicious fusion of premium roasted peanuts and rich, natural cocoa—crafted to satisfy your chocolate cravings without compromising on nutrition. Smooth, creamy, and irresistibly tasty, this spread is packed with plant-based protein, healthy fats, and antioxidants.",
        price: 320,
        originalPrice: 350,
        discount: 9,
        rating: 4.9,
        reviewCount: 98,
        inStock: true,
        freeDelivery: true,
        category: "Butter",
        subCategory: "Peanut Butter",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Made with Real Cocoa",
            "Protein-Rich & Antioxidant-Rich",
            "No Refined Sugar or Preservatives",
            "Vegan & Gluten-Free",
            "Smooth & Creamy",
            "No Trans Fats or Palm Oil"
        ],
        specifications: [
            { name: "Type", value: "Chocolate Peanut Butter" },
            { name: "Weight", value: "300gm" },
            { name: "Packaging", value: "Jar" },
            { name: "Diet Type", value: "Vegan, Gluten-Free" },
            { name: "Country of Origin", value: "India" }
        ],
        variants: [
            { name: "300gm", price: 320, originalPrice: 350 }
        ],
        images: [butterChoclate],
        offers: [
            "Free shipping on ₹499+",
            "Flat ₹20 off on combo purchase"
        ],
        reviews: [],
        benefits: [
            "1. Delicious combo of peanuts and cocoa with protein boost.",
            "2. Satisfies sweet cravings with healthier ingredients.",
            "3. Good source of energy, fiber, and antioxidants."
        ],
        storage: [
            "1. Store in a cool, dry place or refrigerate after opening.",
            "2. Seal tightly to avoid oil separation and spoilage."
        ],
        questions: [],
        relatedProducts: [8, 9]
    },
    {
        id: 15,
        name: "Haronics A2 Gir Cow Bilona Ghee",
        description: "Traditional Purity. Nutritional Excellence.",
        longDescription: "Haronics A2 Gir Cow Bilona Ghee is a golden elixir crafted from the A2 milk of pure-bred Gir cows using the ancient Bilona method. Our ghee is slowly churned from curd, not cream, preserving its natural aroma, grainy texture, and rich nutritional value. Made in small batches, it’s 100% pure, chemical-free, and deeply rooted in Ayurvedic tradition.",
        price: 1350,
        originalPrice: 1500,
        discount: 10,
        rating: 4.9,
        reviewCount: 101,
        inStock: true,
        freeDelivery: true,
        category: "Dairy",
        subCategory: "Ghee",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Made from A2 Milk of Indigenous Gir Cows",
            "Crafted Using Traditional Bilona Method",
            "Rich in Omega-3, Vitamins A, D, E, K & CLA",
            "Supports Digestion & Immunity",
            "Excellent for Cooking & Ayurvedic Use",
            "100% Pure, Natural, and Chemical-Free"
        ],
        specifications: [
            { name: "Type", value: "A2 Bilona Ghee" },
            { name: "Packaging", value: "Glass Jar" },
            { name: "Volume", value: "500ML / 1L" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Lactose-Free" }
        ],
        variants: [
            { name: "200ML", price: 550, originalPrice: 800 },
            { name: "500ML", price: 1350, originalPrice: 1500 },
            { name: "1L", price: 2600, originalPrice: 3000 }
        ],
        images: [ghee1, ghee2],
        offers: [
            "10% off on your first order",
            "Free Shipping on all orders"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [12, 17],
        benefits: [
            "1. Rich in omega-3 fatty acids and vitamins A, D, E, K.",
            "2. Enhances digestion and boosts immunity.",
            "3. Traditional Ayurvedic medicine for overall wellness."
        ],
        storage: [
            "1. Store in an airtight container at room temperature.",
            "2. Keep away from moisture and direct sunlight."
        ]
    },
    {
        id: 16,
        name: "Haronics Cane Jaggery Powder | 100% Natural | Unrefined | Chemical-Free",
        description:
            "Natural sweetness with essential minerals—ideal sugar alternative.",
        longDescription:
            "Haronics Cane Jaggery Powder is a pure and unrefined natural sweetener made from fresh sugarcane juice using traditional methods—without any chemicals, sulphur, or additives. Carefully processed to retain its rich taste and golden-brown color, our jaggery powder is packed with essential minerals like iron, calcium, and magnesium.",
        price: 80,
        originalPrice: 100,
        discount: 20,
        rating: 4.9,
        reviewCount: 130,
        inStock: true,
        freeDelivery: true,
        category: "Sweetener",
        subCategory: "Jaggery",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Natural & Unrefined",
            "Rich in Minerals",
            "No Sulphur, No Bleaching",
            "Boosts Energy & Digestion",
            "Supports Immunity",
            "Quick-Dissolving Powder Form"
        ],
        specifications: [
            { name: "Type", value: "Jaggery Powder" },
            { name: "Packaging", value: "Pouch" },
            { name: "Weight", value: "500gm / 1Kg" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500gm", price: 80, originalPrice: 100 },
            { name: "1Kg", price: 150, originalPrice: 200 }
        ],
        images: [juggery, juggery1, juggery2, juggery3,juggery4],
        offers: [
            "Buy 2kg & Get ₹20 Off",
            "Subscribe & Save Option Available",
            "Free Shipping on Orders Above ₹299"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [6, 8, 9],
        benefits: [
            "1. Natural sweetener rich in iron, helps prevent anemia.",
            "2. Aids digestion and cleanses the liver.",
            "3. Good energy booster with no chemicals or additives."
        ],
        storage: [
            "1. Store in a dry, airtight container to avoid clumping.",
            "2. Keep away from moisture and direct sunlight."
        ]
    },
    {
        id: 17,
        name: "Haronics Farm Honey",
        description: "Raw. Pure. Straight from Nature.",
        longDescription: "Haronics Farm Honey is 100% pure, raw, and unprocessed—harvested directly from naturally nurtured bee farms. Free from additives, artificial sweeteners, or heat processing, our honey retains its natural enzymes, antioxidants, and rich floral aroma. Loaded with energy, it supports immunity, digestion, and serves as a healthier sugar alternative.",
        price: 600,
        originalPrice: 700,
        discount: 14,
        rating: 4.8,
        reviewCount: 95,
        inStock: true,
        freeDelivery: true,
        category: "Sweetener",
        subCategory: "Honey",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural",
            "Unprocessed & Unfiltered",
            "Rich in Enzymes & Antioxidants",
            "No Added Sugar or Preservatives",
            "Supports Immunity & Digestion",
            "Perfect for Daily Use & Home Remedies"
        ],
        specifications: [
            { name: "Type", value: "Raw Honey" },
            { name: "Packaging", value: "Glass Bottle" },
            { name: "Volume", value: "500ML / 1L" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500 gm", price: 550, originalPrice: 700 },
            { name: "1Kg", price: 1000, originalPrice: 1200 }
        ],
        images: [hon1, hon2, hon3, hon4, hon5, hon6],
        offers: [
            "Free Shipping on orders ₹499+",
            "Combo discounts available"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [11, 17],
        benefits: [
            "1. Natural source of antioxidants and antibacterial properties.",
            "2. Boosts immunity and soothes sore throats.",
            "3. Acts as a natural sweetener with health benefits."
        ],
        storage: [
            "1. Store in a glass jar in a cool, dry place.",
            "2. Do not refrigerate; crystallization is natural and reversible."
        ]
    },
    {
        id: 18,
        name: "Haronics Coconut Sugar",
        description: "Naturally Sweet. Wholesomely Better.",
        longDescription: "Haronics Coconut Sugar is a natural sweetener made from the sap of coconut blossoms. Minimally processed to retain nutrients like iron, potassium, and zinc, it has a mild caramel taste and a low glycemic index—perfect for diabetics and health-conscious individuals.",
        price: 150,
        originalPrice: 180,
        discount: 17,
        rating: 4.9,
        reviewCount: 110,
        inStock: true,
        freeDelivery: true,
        category: "Sweetener",
        subCategory: "Coconut Sugar",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Natural & Unrefined",
            "Low Glycemic Index",
            "Rich in Minerals & Antioxidants",
            "No Chemicals or Additives",
            "Perfect for Tea, Coffee & Baking",
            "Vegan | Gluten-Free | Paleo-Friendly"
        ],
        specifications: [
            { name: "Type", value: "Coconut Sugar" },
            { name: "Weight", value: "250gm / 500gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "250gm", price: 150, originalPrice: 180 },
            { name: "500gm", price: 300, originalPrice: 350 },
            { name: "1 Kg", price: 550, originalPrice: 800 }
        ],
        images: [csugar, csugar1, csugar2, csugar3, csugar4, csugar6],
        offers: [
            "Buy 2kg & Get ₹30 Off",
            "Subscribe & Save 10%"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [12, 18],
        benefits: [
            "1. Low glycemic index compared to regular sugar.",
            "2. Retains nutrients like iron, zinc, and potassium.",
            "3. Great for diabetic-friendly sweetening in moderation."
        ],
        storage: [
            "1. Store in an airtight container to avoid moisture.",
            "2. Keep in a cool, dry place away from direct sunlight."
        ]
    },
    {
        id: 19,
        name: "Haronics Palm Sugar",
        description: "Traditional Sweetness. Naturally Wholesome.",
        longDescription: "Haronics Palm Sugar is a natural, unrefined sweetener made from palm nectar using traditional methods. With a rich, caramel flavor and essential minerals like iron and calcium, it’s a healthier, slow-digesting alternative to white sugar.",
        price: 150,
        originalPrice: 180,
        discount: 17,
        rating: 4.7,
        reviewCount: 84,
        inStock: true,
        freeDelivery: true,
        category: "Sweetener",
        subCategory: "Palm Sugar",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Unrefined & Chemical-Free",
            "Low Glycemic Index",
            "Rich in Iron & Calcium",
            "Traditional Processing",
            "Perfect for Indian Sweets & Beverages",
            "Vegan | Gluten-Free | Non-GMO"
        ],
        specifications: [
            { name: "Type", value: "Palm Sugar" },
            { name: "Weight", value: "250gm / 500gm" },
            { name: "Packaging", value: "Pouch" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegan" }
        ],
        variants: [
            { name: "250gm", price: 150, originalPrice: 180 },
            { name: "500gm", price: 300, originalPrice: 350 },
            { name: "1Kg", price: 550, originalPrice: 800 }
        ],
        images: [palm, palm1],
        offers: [
            "Flat ₹10 off on 2 packs",
            "Free shipping over ₹299"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [17],
        benefits: [
            "1. Natural sweetener rich in minerals and antioxidants.",
            "2. Supports digestive health and boosts energy.",
            "3. Better alternative to refined sugar."
        ],
        storage: [
            "1. Store in a cool, dry place to avoid hardening.",
            "2. Keep in an airtight container to preserve freshness."
        ]
    },
    {
        id: 20,
        name: "Haronics Coconut Bowls",
        description: "Sustainably Made. Naturally Beautiful. Mindfully Yours.",
        longDescription: "Haronics Coconut Bowls are handcrafted from real coconut shells, making them a beautiful, biodegradable alternative to plastic serveware. Each bowl is unique in shape and ideal for smoothie bowls, salads, or snacks.",
        price: 250,
        originalPrice: 300,
        discount: 17,
        rating: 4.9,
        reviewCount: 70,
        inStock: true,
        freeDelivery: true,
        category: "Home",
        subCategory: "Serveware",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "Made from Real Coconut Shells",
            "Handcrafted & Polished",
            "Eco-Friendly & Zero-Waste",
            "Each Bowl is Unique",
            "Reusable & Biodegradable",
            "Ideal for Smoothie Bowls & Snacks"
        ],
        specifications: [
            { name: "Type", value: "Coconut Shell Bowl" },
            { name: "Size", value: "Standard" },
            { name: "Packaging", value: "Single Unit" },
            { name: "Country of Origin", value: "India" }
        ],
        variants: [
            { name: "Small", price: 250, originalPrice: 300 },
            { name: "Big", price: 300, originalPrice: 400 }
        ],
        images: [bowl, bowl1],
        offers: [
            "Buy 2 get ₹30 off",
            "Combo packs available"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [],
        benefits: [
            "1. Eco-friendly, reusable, and biodegradable.",
            "2. Adds a natural and aesthetic touch to serving food.",
            "3. Made from real coconut shells, completely chemical-free."
        ],
        storage: [
            "1. Wash by hand with lukewarm water (avoid dishwasher).",
            "2. Dry immediately and keep away from direct heat or sunlight."
        ]
    },
    {
        id: 21,
        name: "Haronics Coco Peat Brick",
        description: "Compact. Convenient. Cultivation-Ready.",
        longDescription: "Haronics Coco Peat Brick is made from 100% natural coconut coir and expands 5–6x when soaked. Ideal for gardening and hydroponics, it improves water retention, root health, and soil aeration for thriving plants.",
        price: 120,
        originalPrice: 150,
        discount: 20,
        rating: 4.5,
        reviewCount: 87,
        inStock: true,
        freeDelivery: true,
        category: "Gardening",
        subCategory: "Coco Peat",
        brand: "Haronics",
        warranty: "N/A",
        returnPolicy: "10 days",
        highlights: [
            "100% Natural Coconut Husk Fiber",
            "Expands Up to 5–6x",
            "Excellent Water Retention & Aeration",
            "Anti-Fungal & Weed-Free",
            "Eco-Friendly & Sustainable",
            "Perfect for All Types of Gardening"
        ],
        specifications: [
            { name: "Type", value: "Coco Peat Brick" },
            { name: "Weight", value: "1 Brick" },
            { name: "Packaging", value: "Compressed Block" },
            { name: "Country of Origin", value: "India" }
        ],
        variants: [
            { name: "5 Kg", price: 300, originalPrice: 500 }
        ],
        images: [brick, brick1],
        offers: [
            "Buy 3 bricks, get 1 free",
            "Bulk discounts available"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [],
        benefits: [
            "1. Excellent soil conditioner and water retainer for gardening.",
            "2. Improves aeration and root development in plants.",
            "3. Eco-friendly and sustainable alternative to soil mixes."
        ],
        storage: [
            "1. Store in a dry place to prevent moisture absorption.",
            "2. Keep in original packaging until ready to use."
        ]
    },

    {
        id: 22,
        name: "Haronics Himalayan Pink Salt | 100% Pure | Unprocessed | Mineral Rich Salt",
        description: "Mineral-rich Himalayan pink salt sourced from ancient mines, unrefined and additive-free for pure wellness.",
        longDescription: "Haronics Himalayan Pink Salt is a pristine, mineral-rich salt harvested from the ancient Himalayan salt mines. It contains over 80 trace minerals such as potassium, calcium, and magnesium, offering unmatched purity and health benefits. Unprocessed and free from additives, it’s ideal for daily cooking, bath soaks, and natural therapies. A versatile addition to your healthy lifestyle, this salt helps regulate hydration, pH balance, and promotes relaxation.",
        price: 120,
        originalPrice: 150,
        discount: 20,
        rating: 4.6,
        reviewCount: 75,
        inStock: true,
        freeDelivery: true,
        category: "Grocery",
        subCategory: "Salt",
        brand: "Haronics",
        warranty: "NA",
        returnPolicy: "10 days",
        highlights: [
            "100% Natural & Unrefined Himalayan Salt",
            "Rich in 80+ Trace Minerals like Calcium & Magnesium",
            "Ideal for Cooking, Detox Baths & Oral Rinses",
            "No Bleaching, Anti-Caking Agents or Preservatives",
            "Supports Hydration & pH Balance",
            "Fine & Coarse Grain Options"
        ],
        specifications: [
            { name: "Type", value: "Himalayan Pink Salt" },
            { name: "Packaging", value: "Pouch" },
            { name: "Shelf Life", value: "24 months" },
            { name: "Storage", value: "Airtight container in a dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "500GM", price: 100, originalPrice: 150 },
            { name: "1KG", price: 200, originalPrice: 250 }
        ],
        images: [
            salt,
            salt2,
            salt1,

        ],
        offers: [
            "Buy 2 Get 1 Free on Haronics Salts",
            "Free delivery on orders above ₹499"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 2, 4],
        benefits: [
            "1. Contains trace minerals like calcium, magnesium, and potassium.",
            "2. Helps balance body’s pH levels and improve hydration.",
            "3. Natural and less processed compared to table salt."
        ],
        storage: [
            "1. Store in a moisture-free airtight container.",
            "2. Keep away from humidity and direct heat."
        ]
    },
    {
        id: 23,
        name: "Haronics Wood/Cold Pressed Almond Oil | 100% Natural | Unrefined | Preservative-Free",
        description: "Pure, natural, and nutrient-rich almond oil extracted using traditional wooden Ghani method for optimal skin, hair, and health benefits.",
        longDescription: "Haronics Cold Pressed Almond Oil is a pure, nutrient-rich oil extracted from premium almonds using the traditional wooden Ghani method. This chemical-free process ensures maximum retention of natural nutrients, aroma, and flavor. Rich in Vitamin E, antioxidants, and essential fatty acids, our almond oil is ideal for skin and hair nourishment, as well as light culinary use. 100% natural, unrefined, and preservative-free — it’s your all-in-one wellness companion for a holistic lifestyle.",
        price: 1200,
        originalPrice: 1500,
        discount: 20,
        rating: 4.7,
        reviewCount: 120,
        inStock: true,
        freeDelivery: true,
        category: "Oil",
        subCategory: "Almond Oil",
        brand: "Haronics",
        warranty: "30 days",
        returnPolicy: "10 days",
        highlights: [
            "100% Pure & Natural – Traditional Cold Pressed",
            "Rich in Vitamin E, Antioxidants & Essential Fatty Acids",
            "Chemical-Free, Unrefined & Preservative-Free",
            "Suitable for Cooking, Skin & Hair Care",
            "Gentle Enough for Baby Massage",
            "Supports Brain Health & Anti-Aging"
        ],
        specifications: [
            { name: "Type", value: "Almond Oil" },
            { name: "Packaging", value: "Bottle" },
            { name: "Shelf Life", value: "9 months" },
            { name: "Storage", value: "Cool, dry place" },
            { name: "Country of Origin", value: "India" },
            { name: "Diet Type", value: "Vegetarian" }
        ],
        variants: [
            { name: "250ML", price: 1200, originalPrice: 1500 },
            { name: "500ML", price: 2000, originalPrice: 3000 },
            { name: "1L", price: 4000, originalPrice: 5000 }
        ],
        images: [
            almond,
            almond1,
            almond2,
            almond3,
            almond4,
        ],
        offers: [
            "10% off on first purchase",
            "Buy 2 Get 1 Free on Haronics Oils",
            "Free delivery on orders above ₹499"
        ],
        reviews: [],
        questions: [],
        relatedProducts: [1, 3, 4],
        benefits: [
            "1. Rich in Vitamin E and antioxidants – good for skin and hair.",
            "2. Helps reduce inflammation and improve heart health.",
            "3. Natural moisturizer and massage oil for babies and adults."
        ],
        storage: [
            "1. Store in a cool, dark place in a sealed glass bottle.",
            "2. Keep away from moisture and light to retain nutrients."
        ]
    },

];

const ProductDetailPage = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [selectedVariant, setSelectedVariant] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [activeTab, setActiveTab] = useState("description");
    const [isZoomed, setIsZoomed] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
    const [expandedSection, setExpandedSection] = useState(null);
    const [showAllReviews, setShowAllReviews] = useState(false);
    const [showAllQuestions, setShowAllQuestions] = useState(false);
    const [relatedProducts, setRelatedProducts] = useState([]);

    const imageRef = useRef(null);
    const zoomContainerRef = useRef(null);

    useEffect(() => {
        setLoading(true);
        setProduct(null);
        setShowAllReviews(false);
        setShowAllQuestions(false);

        setTimeout(() => {
            const foundProduct = products.find((p) => p.id === Number.parseInt(id));
            setProduct(foundProduct);
            setLoading(false);

            if (foundProduct && foundProduct.variants) {
                setSelectedVariant(0);
            }

            if (foundProduct && foundProduct.relatedProducts) {
                const related = foundProduct.relatedProducts
                    .map((relatedId) => products.find((p) => p.id === relatedId))
                    .filter(Boolean);
                setRelatedProducts(related);
            } else {
                setRelatedProducts([]);
            }
        }, 800);
    }, [id]);
    const handleWhatsAppRedirect = () => {
        const phoneNumber = '917019272992';
        const message = "Hi, I'm interested in purchasing your products. Could you please share more details?"
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank'); // Opens WhatsApp in new tab
    };
    const handleMouseMove = (e) => {
        if (!imageRef.current || !zoomContainerRef.current) return;

        const { left, top, width, height } = imageRef.current.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        setZoomPosition({ x, y });
    };

    const handleImageClick = () => {
        setIsZoomed(!isZoomed);
    };

    const handleQuantityChange = (change) => {
        const newQuantity = quantity + change;
        if (newQuantity >= 1 && newQuantity <= 10) {
            setQuantity(newQuantity);
        }
    };

    const handleVariantSelect = (index) => {
        setSelectedVariant(index);
    };

    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;

        for (let i = 0; i < fullStars; i++) {
            stars.push(
                <span key={`full-${i}`} className="star">
                    ★
                </span>
            );
        }

        if (hasHalfStar) {
            stars.push(
                <span key="half" className="star half">
                    ★
                </span>
            );
        }

        const emptyStars = 5 - stars.length;
        for (let i = 0; i < emptyStars; i++) {
            stars.push(
                <span key={`empty-${i}`} className="star empty">
                    ☆
                </span>
            );
        }

        return stars;
    };

    if (loading) {
        return (
            <div className="product-detail-loading">
                <div className="loading-spinner">

                </div>
                <p>Loading product details...</p>

            </div>
        );
    }

    if (!product) {
        return (
            <div className="product-not-found">
                <h2>Product Not Found</h2>
                <p>Sorry, we couldn't find the product you're looking for.</p>
                <Link to="/" className="back-button">
                    Back to Home
                </Link>
            </div>
        );
    }

    const currentVariant = product.variants[selectedVariant];

    return (
        <div className="product-detail-page">
            {/* Breadcrumb Navigation */}
            <div className="breadcrumb mt-3">
                <Link to="/">Home</Link> &gt; <Link to="/">{product.category}</Link> &gt;
                <span>{product.name}</span>
            </div>

            {/* Main Product Section */}
            <div className="product-main-container">
                {/* Left Column - Product Images */}

                <div className="product-images-column">
                    <div className="image-gallery">
                        <div className="thumbnails-container">
                            {product.images.map((image, index) => (
                                <div
                                    key={index}
                                    className={`thumbnail ${mainImageIndex === index ? "active" : ""}`}
                                    onClick={() => setMainImageIndex(index)}
                                >
                                    <img src={image || "/placeholder.svg"} alt={`${product.name} - View ${index + 1}`} />
                                </div>
                            ))}
                        </div>

                        <div
                            className={`main-image-container ${isZoomed ? "zoomed" : ""}`}
                            onMouseMove={isZoomed ? handleMouseMove : null}
                            onMouseLeave={() => setIsZoomed(false)}
                            onClick={handleImageClick}
                            ref={zoomContainerRef}
                        >
                            <img
                                ref={imageRef}
                                src={product.images[mainImageIndex] || "/placeholder.svg"}
                                alt={product.name}
                                className="main-image"
                            />
                            {isZoomed && (
                                <div
                                    className="zoomed-image"
                                    style={{
                                        backgroundImage: `url(${product.images[mainImageIndex]})`,
                                        backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                                    }}
                                ></div>
                            )}
                            <div className="image-navigation">
                                <button
                                    className="nav-button prev"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setMainImageIndex((prev) => (prev === 0 ? product.images.length - 1 : prev - 1));
                                    }}
                                >
                                    ❮
                                </button>
                                <button
                                    className="nav-button next"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setMainImageIndex((prev) => (prev === product.images.length - 1 ? 0 : prev + 1));
                                    }}
                                >
                                    ❯
                                </button>
                            </div>
                            <div className="zoom-hint">Click to {isZoomed ? "exit zoom" : "zoom"}</div>
                        </div>

                        <div className="product-actions">
                            {/* <button className="action-button add-to-cart">
                                <span className="icon">🛒</span> ADD TO CART
                            </button> */}
                            <button onClick={handleWhatsAppRedirect} className="action-button buy-now">
                                <span className="icon">⚡</span> BUY NOW
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right Column - Product Info */}
                <div className="product-info-column">
                    <div className="product-header">
                        <h4 className="product-title">{product.name}</h4>
                        <div className="product-rating-summary">
                            <div className="rating-badge">
                                {product.rating} <span className="star">★</span>
                            </div>
                            <div className="rating-count">
                                {product.reviewCount.toLocaleString()} Ratings & {Math.round(product.reviewCount / 3).toLocaleString()} Reviews
                            </div>

                        </div>
                    </div>

                    <div className="product-price-container">
                        <div className="price-section">
                            <span className="current-price">₹{currentVariant.price}</span>
                            <span className="original-price">₹{currentVariant.originalPrice}</span>
                            <span className="discount-percentage">
                                {Math.round(((currentVariant.originalPrice - currentVariant.price) / currentVariant.originalPrice) * 100)}% off
                            </span>
                        </div>
                        <div className="tax-info">Inclusive of all taxes</div>
                    </div>

                    {/* Variants Selection */}
                    {product.variants && product.variants.length > 1 && (
                        <div className="product-variants">
                            <h4 className="section-title">Select Size</h4>
                            <div className="variants-container">
                                {product.variants.map((variant, index) => (
                                    <button
                                        key={index}
                                        className={`variant-button ${selectedVariant === index ? "selected" : ""}`}
                                        onClick={() => handleVariantSelect(index)}
                                    >
                                        <span className="variant-name">{variant.name}</span>
                                        <span className="variant-price">₹{variant.price}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {product.offers && product.offers.length > 0 && (
                        <div className="product-offers">
                            {/* <h4 className="section-title">Available Offers</h4>
                            <ul className="offers-list">
                                {product.offers.map((offer, index) => (
                                    <li key={index} className="offer-item">
                                        <span className="icon">🏷️</span>
                                        <span className="offer-text">{offer}</span>
                                    </li>
                                ))}
                            </ul> */}
                        </div>
                    )}

                    {/* Highlights */}
                    {product.highlights && product.highlights.length > 0 && (
                        <div className="product-highlights">
                            <h3 className="section-title">Highlights</h3>
                            <ul className="highlights-list">
                                {product.highlights.map((highlight, index) => (
                                    <li key={index} className="highlight-item">
                                        <span className="icon">✓</span>
                                        <span>{highlight}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}


                </div>
            </div>

            {/* Tabs Section */}
            <div className="product-tabs">
                <div className="tabs-header">
                    <button
                        className={`tab-button ${activeTab === "description" ? "active" : ""}`}
                        onClick={() => setActiveTab("description")}
                    >
                        Description
                    </button>
                    <button
                        className={`tab-button ${activeTab === "specifications" ? "active" : ""}`}
                        onClick={() => setActiveTab("specifications")}
                    >
                        Specifications
                    </button>
                    <button
                        className={`tab-button ${activeTab === "reviews" ? "active" : ""}`}
                        onClick={() => setActiveTab("reviews")}
                    >
                        Reviews
                    </button>
                    {/* <button
                        className={`tab-button ${activeTab === "questions" ? "active" : ""}`}
                        onClick={() => setActiveTab("questions")}
                    >
                        Questions
                    </button> */}
                </div>

                <div className="tabs-content">
                    {/* Description Tab */}
                    <div className={`tab-panel ${activeTab === "description" ? "active" : ""}`}>
                        <div className="product-description">
                            <h3>Product Description</h3>
                            <div className="description-content">
                                <p>{product.longDescription}</p>
                                <div className="description-sections">
                                    <div className={`description-section ${expandedSection === "usage" ? "expanded" : ""}`}>
                                        {/* <h4 onClick={() => toggleSection("usage")}>
                                            How to Use <span className="toggle-icon">{expandedSection === "usage" ? "−" : "+"}</span>
                                        </h4> */}
                                        {expandedSection === "usage" && (
                                            <div className="section-content">
                                                {/* <p>
                                                    <strong>For Cooking:</strong> Use 1-2 tablespoons in place of other cooking oils. Ideal for
                                                    sautéing, baking, and medium-heat cooking.
                                                </p>
                                                <p>
                                                    <strong>For Skin:</strong> Apply a small amount to clean skin as a natural moisturizer. Can be
                                                    used on face and body.
                                                </p>
                                                <p>
                                                    <strong>For Hair:</strong> Warm a tablespoon between palms and apply to hair from mid-length
                                                    to ends. Leave for 30 minutes or overnight before washing.
                                                </p> */}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`description-section ${expandedSection === "benefits" ? "expanded" : ""}`}>
                                        <h4 onClick={() => toggleSection("benefits")}>
                                            Benefits <span className="toggle-icon">{expandedSection === "benefits" ? "−" : "+"}</span>
                                        </h4>
                                        {expandedSection === "benefits" && (
                                            <div className="section-content">
                                                {product.benefits.map((item, index) => (
                                                    <li key={index}>
                                                        {item}
                                                    </li>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`description-section ${expandedSection === "storage" ? "expanded" : ""}`}>
                                        <h4 onClick={() => toggleSection("storage")}>
                                            Storage Instructions{" "}
                                            <span className="toggle-icon">{expandedSection === "storage" ? "−" : "+"}</span>
                                        </h4>
                                        {expandedSection === "storage" && (
                                            <div className="section-content">
                                                {product.storage.map((item, index) => (
                                                    <li key={index}>
                                                        {item}
                                                    </li>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Specifications Tab */}
                    <div className={`tab-panel ${activeTab === "specifications" ? "active" : ""}`}>
                        <div className="product-specifications">
                            <h3>Specifications</h3>
                            <table className="specifications-table">
                                <tbody>
                                    {product.specifications &&
                                        product.specifications.map((spec, index) => (
                                            <tr key={index} className={index % 2 === 0 ? "even" : "odd"}>
                                                <td className="spec-name">{spec.name}</td>
                                                <td className="spec-value">{spec.value}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Reviews Tab */}
                    <div className={`tab-panel ${activeTab === "reviews" ? "active" : ""}`}>
                        <div className="product-reviews">
                            <div className="reviews-header">
                                <h3>Ratings & Reviews</h3>
                                {/* <button className="write-review-button">Write a Review</button> */}
                            </div>

                            <div className="reviews-summary">
                                <div className="rating-overview">
                                    <div className="average-rating">{product.rating}</div>
                                    <div className="rating-stars">{renderStars(product.rating)}</div>
                                    <div className="total-ratings">{product.reviewCount.toLocaleString()} ratings</div>
                                </div>

                                <div className="rating-distribution">
                                    <div className="rating-bar">
                                        <span className="rating-label">5★</span>
                                        <div className="bar-container">
                                            <div className="bar-fill" style={{ width: "70%" }}></div>
                                        </div>
                                        <span className="rating-percentage">70%</span>
                                    </div>
                                    <div className="rating-bar">
                                        <span className="rating-label">4★</span>
                                        <div className="bar-container">
                                            <div className="bar-fill" style={{ width: "20%" }}></div>
                                        </div>
                                        <span className="rating-percentage">20%</span>
                                    </div>
                                    <div className="rating-bar">
                                        <span className="rating-label">3★</span>
                                        <div className="bar-container">
                                            <div className="bar-fill" style={{ width: "5%" }}></div>
                                        </div>
                                        <span className="rating-percentage">5%</span>
                                    </div>
                                    <div className="rating-bar">
                                        <span className="rating-label">2★</span>
                                        <div className="bar-container">
                                            <div className="bar-fill" style={{ width: "3%" }}></div>
                                        </div>
                                        <span className="rating-percentage">3%</span>
                                    </div>
                                    <div className="rating-bar">
                                        <span className="rating-label">1★</span>
                                        <div className="bar-container">
                                            <div className="bar-fill" style={{ width: "2%" }}></div>
                                        </div>
                                        <span className="rating-percentage">2%</span>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="reviews-filter">
                                <select className="filter-dropdown">
                                    <option>Most Helpful</option>
                                    <option>Recent</option>
                                    <option>Positive First</option>
                                    <option>Critical First</option>
                                </select>
                            </div> */}

                            <div className="reviews-list">
                                {(showAllReviews ? product.reviews : product.reviews?.slice(0, 2))?.map((review) => (
                                    <div key={review.id} className="review-item">
                                        <div className="review-header">
                                            <div className="review-rating-badge">{review.rating}★</div>
                                            <div className="review-title">{review.title}</div>
                                        </div>
                                        <div className="review-content">{review.comment}</div>
                                        <div className="review-footer">
                                            <div className="reviewer-info">
                                                <span className="reviewer-name">{review.user}</span>
                                                {review.verified && <span className="verified-badge">Verified Purchase</span>}
                                                <span className="review-date">{review.date}</span>
                                            </div>
                                            {/* <div className="review-actions">
                                                <button className="helpful-button">
                                                    <span className="icon">👍</span> Helpful ({review.helpful})
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {product.reviews?.length > 2 && (
                                <button className="show-more-button" onClick={() => setShowAllReviews(!showAllReviews)}>
                                    {showAllReviews ? "Show Less" : `Show All ${product.reviews.length} Reviews`}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Questions Tab */}
                    {/* <div className={`tab-panel ${activeTab === "questions" ? "active" : ""}`}>
                        <div className="product-questions">
                            <div className="questions-header">
                                <h3>Questions & Answers</h3>
                                <div className="question-search">
                                    <input type="text" placeholder="Search questions..." />
                                    <button className="search-button">Search</button>
                                </div>
                            </div>

                            <div className="questions-list">
                                {(showAllQuestions ? product.questions : product.questions?.slice(0, 2))?.map((item) => (
                                    <div key={item.id} className="question-item">
                                        <div className="question">
                                            <span className="icon">Q:</span>
                                            <div className="question-text">{item.question}</div>
                                        </div>
                                        <div className="answer">
                                            <span className="icon">A:</span>
                                            <div className="answer-text">{item.answer}</div>
                                        </div>
                                        <div className="question-meta">
                                            <span>
                                                Asked by {item.askedBy} - {item.date}
                                            </span>
                                            <span>Answered by {item.answeredBy}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {product.questions?.length > 2 && (
                                <button className="show-more-button" onClick={() => setShowAllQuestions(!showAllQuestions)}>
                                    {showAllQuestions ? "Show Less" : `Show All ${product.questions.length} Questions`}
                                </button>
                            )}

                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default ProductDetailPage;